import React from "react";
import S from "./Pagination.styled";
export default function Pagination({ text, itemsLength, currentPage, itemsPerPage, handleNext, handlePrevious, handleItemsPerPage, }) {
    const maxPage = Math.ceil(itemsLength / itemsPerPage);
    return (React.createElement(S.Wrapper, null,
        React.createElement(S.Text, null, `${currentPage} / ${maxPage} page(s) • ${itemsLength} ${text}`),
        React.createElement(S.HStack, null,
            React.createElement(S.Select, { value: itemsPerPage.toString(), onChange: (e) => handleItemsPerPage(parseInt(e.target.value, 10)), name: "pagination" },
                React.createElement("option", { value: "5" }, "5"),
                React.createElement("option", { value: "10" }, "10"),
                React.createElement("option", { value: "25" }, "25")),
            React.createElement(S.Button, { disabled: currentPage === 1, onClick: handlePrevious }, "Previous"),
            React.createElement(S.Button, { disabled: currentPage >= maxPage, onClick: handleNext, "data-testid": "pagination-next" }, "Next"))));
}
//# sourceMappingURL=Pagination.js.map